import { RootState } from '../stores'

export const selectTheme = (state: RootState) => state.theme.themeMode
